import { Component, Input } from '@angular/core';
import { InfoPanelGridCell } from '../info-panel-grid-cell';

@Component({
  selector: 'app-info-panel-field',
  standalone: true,
  imports: [],
  templateUrl: './info-panel-field.component.html',
  styleUrl: './info-panel-field.component.css',
})
export class InfoPanelFieldComponent extends InfoPanelGridCell {
  @Input() label: string | null | undefined;
  @Input() value: string | number | null | undefined;
}
